import React from "react";
import { GameStateInterface, gameStateDefaultInterface } from './GameStateInterface';

export const GamestateContext = React.createContext<GameStateInterface>(gameStateDefaultInterface);
export const GamestateProvider = GamestateContext.Provider;
export const GamestateConsume = GamestateContext.Consumer;